/**
 * The SingleSelector will manage a state variable in you're controlling components
 * state. This will allow at most one item to be selected. Meta-click will unselect
 * a selected item.
 * @property {Component} component the component whose state is managed
 * @property {string} stateKey the name of the selection group in the state
 * @property {object} options
 * @property {function} options.onSelect called with the item to select or null if remove
 * is occurring. If this function returns false, the selection is cancelled. This will
 * be invoked prior to calling component.setState()
 * @property {function} [options.idFunc] a function used to return item's id. The id will be stored
 * in the selection group.
 * @property {string} [options.idKey] the key of the item's id. The id will be stored
 * in the selection group. This is unused if idFunc is supplied
 * @property {object} options.useMeta if false, the use of meta to remove items will be
 * disabled
 **/
export default class SingleSelector {
  constructor(component, stateKey, {
    onSelect,
    idKey,
    idFunc,
    useMeta = true
  } = {}) {
    this.component = component;
    this.stateKey = stateKey;
    this.idKey = idKey;
    this.idFunc = idFunc;
    this.useMeta = useMeta;
    this.allowSelect = onSelect;
  }
  key(item) {
    if (this.idFunc) {
      return this.idFunc(item);
    }
    return this.idKey ? item[this.idKey] : item;
  }
  isSelected(item) {
    const key = this.key(item);
    // do == so a number will equal a string 
    // eslint-disable-next-line eqeqeq
    return this.component.state[this.stateKey] == key;
  }
  onSelect(event) {
    const item = event.value;
    const meta = event.sourceEvent && event.sourceEvent.metaKey;
    const selected = this.isSelected(item);
    const cb = event.onSelect ? () => {
      event.onSelect(item);
    } : null;
    if (this.useMeta && meta && selected) {
      // Handle emptying the selection
      if (this.allowSelect == null || this.allowSelect(null) !== false) {
        this.component.setState({
          [this.stateKey]: null
        }, cb);
      }
      return;
    }
    if (selected) {
      // already selected
      return;
    }
    const key = this.key(item);
    if (this.allowSelect == null || this.allowSelect(item) !== false) {
      this.component.setState({
        [this.stateKey]: key
      }, cb);
    }
  }
}